// @ts-check
import React, { StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import Select, { ReactSelectProps, Option, OptionValues } from 'react-select'; // eslint-disable-line no-unused-vars

/**
 * @param {Option<OptionValues>} value
 * @returns {string[]}
 */
function convertDelimitedStringToArray(value) {
  return (value || '').split(',');
}

/**
 * This wrapper adapts react-select (when used with multi=true) to emit its value as an array of simple values.
 * instead of an array of objects or a comma-delimited string of simple values
 *
 * react-select has two value modes:
 *
 *   1. simpleValue=true means the component emits the selected options valueKey property.
 *   2. simpleValue=false means the component emits the selection option object itself.
 *
 * However, for a multi select, we get the following
 *
 *   1. simpleValue=true means the component emits the selected options' valueKey properties as a comma-delimited string (e.g. "uuid1, uuid2, uuid3")
 *   2. simpleValue=false means the compononent emits the selected options objects themselves in an array.
 *
 * What we really want, is a 3rd behavior:
 *
 *   3. simpleValue='simpleArray' means multi select components emit the selection options' valueKey properties as an array of simple values (e.g. [uuid1, uuid2, uuid3])
 *
 * This adpater provides the 3rd behavior.
 *
 * @type { StatelessComponent<{simpleValue?: true | false | "simpleArray"} & ReactSelectProps<OptionValues>> }
 */
const SelectWithArrayOfSimpleValues = props =>
  props.simpleValue === 'simpleArray' ? (
    <Select
      {...props}
      onChange={value => props.onChange(convertDelimitedStringToArray(value))}
      simpleValue
    />
  ) : (
    <Select {...props} />
  );

SelectWithArrayOfSimpleValues.displayName = 'SelectWithArrayOfSimpleValues';

export default SelectWithArrayOfSimpleValues;
